import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import * as firebase from 'firebase/app';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  public profileList: firebase.database.Reference;
  baseUrl: string;
  apiKey: string;

  constructor(private db: AngularFireDatabase, private http: HttpClient) {
    this.baseUrl = localStorage.getItem('baseUrl');
    this.apiKey = localStorage.getItem('APIKey');
    this.profileList = db.database.ref('/users');
  }

  setProfile(user, profileField) {
    return firebase.database().ref(`users/${user}/fields`).update(profileField);
  }

  editJoomlaProfile(username, password, email, profileField) {
    const sessionId = localStorage.getItem('session_id');
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Authorization': 'BASIC ' + this.apiKey
    });
    const options = {
      headers: httpHeaders
    };
    return this.http.get(`${this.baseUrl}endpoint-user?module=user&action=put&resource=profile&username=${username}&password=${password}&email=${email}&name=${name}&session_id=${sessionId}&com_fields=${profileField}&api_key=${this.apiKey}`, options);
  }
}
